import { render, staticRenderFns } from "./englishJournals.vue?vue&type=template&id=a90d4fc8&scoped=true"
import script from "./englishJournals.vue?vue&type=script&lang=js"
export * from "./englishJournals.vue?vue&type=script&lang=js"
import style0 from "./englishJournals.vue?vue&type=style&index=0&id=a90d4fc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90d4fc8",
  null
  
)

export default component.exports